import { columnSettings, tableWidth } from "./report-template-setting";
import { format } from "date-fns";

const settings = {};
for (let columnSetting of columnSettings) {
  settings[columnSetting.field] = columnSetting;
}

const ReportTemplateDetail = (props) => {
  const {
    mykey,
    no,
    customer_code,
    customer_name,
    quantity,
    transaction_date,
    number,
    product_package_name,
  } = props;

  const numberFormat = (number) => {
    // not currency
    return new Intl.NumberFormat("id-ID", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(number);
  };

  return (
    <tr
      key={mykey}
      className={`row-start-start ${tableWidth} text-sm text-slate-700 !items-stretch`}
    >
      <td
        className={`${settings["no"].layout} ${settings["no"].width} border-zinc-300 border border-t-0  px-2 pt-2 pb-1 `}
      >
        {no}
      </td>

      <td
        className={`${settings["customer_code"].layout} ${settings["customer_code"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
      >
        {customer_code}
      </td>

      <td
        className={`${settings["customer_name"].layout} ${settings["customer_name"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
      >
        {customer_name}
      </td>

      <td
        className={`${settings["quantity"].layout} ${settings["quantity"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
      >
        {numberFormat(quantity)}
      </td>

      <td
        className={`${settings["transaction_date"].layout} ${settings["transaction_date"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1`}
      >
        {transaction_date
          ? format(
              new Date(transaction_date),
              settings["transaction_date"].format
            )
          : "-"}
      </td>

      <td
        className={`${settings["product_package_name"].layout} ${settings["product_package_name"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
      >
        <span className="text-xs">{product_package_name}</span>
      </td>
    </tr>
  );
};

export default ReportTemplateDetail;
